export default {
  getAvailableSubscriptionList: (state) => {
    return state.availableSubscriptionsList
  }
}